/**
 * Created by yoavp on 1/4/2016.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var CONST = require("const");
    var UsersListExportModel = require("user-management-models/UsersListExportModel");


    var UserManagementUtilities;
    var errorNotifier;

    UserManagementUtilities = {

        hasExportAcUsersData: function() {
            return LE.sessionManager.hasExportAcUsersData();
        },

        exportAllList: function() {
            if(errorNotifier) {
                errorNotifier.close();
            }
            var startNotifier = LE.LEUserManagement.notifier.showInfo(LE.translator.translate("LEUserManagement.exportUsers.notification"));
            var fileName = UserManagementUtilities._generateFileName();
            var tempModel = new UsersListExportModel({fileName: fileName});

            tempModel.fetch({
                success: function (model, response, options) {
                    LE.LEUserManagement.logger.debug("fetch content success - file will download", "UserManagementUtilities:_exportUsersList");
                },
                error: function (model, response, options) {
                    startNotifier.close();
                    errorNotifier = LE.LEUserManagement.notifier.showError({
                        title: LE.translator.translate("LEFramework.global.export.failed"),
                        content: LE.translator.translate("LEFramework.global.please.try.again"),
                        type: CONST.SYSTEM_NOTIFICATIONS.ERROR,
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.try.again"),
                            callback: UserManagementUtilities.exportAllList
                        }
                    });
                },
                timeout: 180000
            });
        },

        _generateFileName: function() {
            var newDate = new Date();
            var year = newDate.getFullYear();
            var day = newDate.getDate();
            var month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][newDate.getMonth()];
            var hours = newDate.getHours();
            var minutes = newDate.getMinutes();
            var seconds = newDate.getSeconds();

            var str = "UsersExport_" + year + month + day + '_' + hours + "-" + minutes + "-" + seconds + ".zip";
            return str;
        }
    };

    return UserManagementUtilities;
});

